import React from 'react';
import Text from '../text/Text';
import classNames from 'classnames';
import { addingZeroToNumber } from '../../utils/number';

type Props = {
  type: string;
  count: number;
  active: string;
  onClick: (data: string) => void;
};

const TimeItemList = ({ type, count, active, onClick }: Props) => (
  <div className="time-items d-flex flex-column align-items-center">
    <div className="mb-3">
      <Text weight="bold">{type}</Text>
    </div>

    {(type === 'Hour' || type === 'Minute') && (
      <div className="overflow-y-scroll">
        {Array(count)
          .fill(0)
          .map((_, i) => (
            <div
              className={classNames(
                'd-flex align-items-center justify-content-center pointer py-4 px-8 mx-4 rounded-2',
                {
                  'bg-primary text-white':
                    type === 'Hour'
                      ? active === addingZeroToNumber(count === 12 ? i + 1 : i)
                      : active === addingZeroToNumber(i),
                },
              )}
              key={addingZeroToNumber(i + 1)}
              onClick={() => {
                if (type === 'Hour') {
                  onClick(addingZeroToNumber(count === 12 ? i + 1 : i));
                } else {
                  onClick(addingZeroToNumber(i));
                }
              }}
            >
              <Text>
                {addingZeroToNumber(
                  type === 'Hour' && count === 12 ? i + 1 : i,
                )}
              </Text>
            </div>
          ))}
      </div>
    )}

    {type === 'AM/PM' && (
      <div className="d-flex flex-column justify-content-center overflow-y-auto ">
        {Array(2)
          .fill(0)
          .map((_, i) => {
            const activeMeridiem = active === 'AM' ? 0 : 1;
            return (
              <div
                key={i}
                className={classNames(
                  'd-flex align-items-center justify-content-center pointer py-4 px-8 rounded-2',
                  {
                    'bg-primary text-white': i === activeMeridiem,
                  },
                )}
                onClick={() => onClick(i === 0 ? 'AM' : 'PM')}
              >
                <Text>{i === 0 ? 'AM' : 'PM'}</Text>
              </div>
            );
          })}
      </div>
    )}
  </div>
);

export default TimeItemList;
